import {Button, Col, Modal, ProgressBar, Row} from "react-bootstrap";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import DateBox from "../../../../primer/DateBox";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import moment from "moment";
import axios from "axios";
import {toast} from "react-toastify";
import {
    setInsertNewPrimerPosListData,
    setPrimerPosRequestData, setSelectedPrimerPosList
} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import Input from "../../../../common/Input";
import {FaCheck} from "react-icons/fa";
import {Space, Switch} from "antd";
import {MdCancel} from "react-icons/md";
import useMediaQuery from "../../../../../hooks/useMediaQuery";
import {openPrimerPOSReport} from "../../../../../_helpers/tabOpeners";

const InsertPosListModal = () => {
    const dispatch = useDispatch();
    const show = useSelector((state) => state.CLIENTS_DATA.insertNewPrimerPosListData.show);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const requestData = useSelector((state) => state.CLIENTS_DATA.primerPosRequestData);
    const isMobileScreen = useMediaQuery("(max-width: 768px)");
    const insertListData = useSelector((state) => state.CLIENTS_DATA.insertNewPrimerPosListData);
    const shippingDate = useSelector((state) => state.CLIENTS_DATA.insertNewPrimerPosListData.shippingDate);
    const [vouchersLoader, setVouchersLoader] = useState(false);
    const [listLoader, setListLoader] = useState(false);
    const [showNotFoundMessage, setShowNotFoundMessage] = useState(false);
    const [showUnchecked, setShowUnchecked] = useState(false);
    const savedVouchers = useSelector((state) => state.CLIENTS_DATA.insertNewPrimerPosListData.savedVouchers);
    const voucherInput = useSelector((state) => state.CLIENTS_DATA.insertNewPrimerPosListData.voucherInput);


    const loadVouchers = () => {
        if(!isEmpty(shippingDate)) {
            setVouchersLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-retrieve-list", {shippingDate: moment(shippingDate).format("DD/MM/YYYY")}, {headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if(res.data.status === "200") {
                    dispatch(setInsertNewPrimerPosListData({...insertListData, savedVouchers: res.data.data}));
                    setTimeout(() => {
                        document.getElementById("check-voucher-input")?.focus();
                    }, 200)
                    toast.success(res.data.message);
                } else {
                    if(res.data.status === "422") dispatch(setInsertNewPrimerPosListData({...insertListData, savedVouchers: []}));
                    toast.error(res.data.message);
                }
                setVouchersLoader(false);
            }).catch((error) => {
                toast.error(error);
                console.log(error);
                setVouchersLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά. Παρακαλώ ξαναπροσπαθήστε!");
        }
    }

    const checkVoucher = () => {
        const findVoucher = savedVouchers.find((el) => el.acsVoucher === voucherInput.trim());
        let listData = structuredClone(insertListData);
        listData.voucherInput = "";
        if(!findVoucher) toast.error("ΠΡΟΣΟΧΗ! Ο συγκεκριμένος αριθμός voucher δεν υπάρχει στην λίστα!");
        if(findVoucher?.checked) toast.error("Ο συγκεκριμένος αριθμός voucher έχει ήδη σκαναριστεί και ελεγχθεί!");
        if(findVoucher && !findVoucher?.checked) {
            listData.savedVouchers = savedVouchers.map(item => item.acsVoucher === voucherInput.trim() ? { ...item, checked: true } : item);
        }
        document.getElementById("check-voucher-input")?.focus();
        toast.success("Επιτυχής Έλεγχος Voucher!");
        dispatch(setInsertNewPrimerPosListData(listData));
    }

    const createAcsList = () => {
        if(savedVouchers.length > 0) {
            setListLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-acs-list", {action: "create", vouchers: savedVouchers}, {headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if(res.data.status === "200") {
                    toast.success(res.data.message);
                    if(res.data?.notFoundList && res.data?.notFoundList?.length > 0) {
                        const notFoundList = res.data.notFoundList;
                        let listData = structuredClone(insertListData);
                        listData.savedVouchers.map((voucher) => {
                            if(notFoundList.find((el) => el === voucher)) {
                                voucher.notFound = true;
                            }
                            return voucher;
                        });
                        setShowNotFoundMessage(true);
                        dispatch(setInsertNewPrimerPosListData(listData));
                    } else {
                        dispatch(setInsertNewPrimerPosListData({show: false, shippingDate: new Date(), savedVouchers: [], voucherInput: ""}));
                        dispatch(setSelectedPrimerPosList({...res.data.data, print: true}));
                    }
                } else {
                    toast.error(res.data.message);
                }
                setListLoader(false);
            }).catch((error) => {
                toast.error(error);
                console.log(error);
                setListLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά. Παρακαλώ ξαναπροσπαθήστε!");
        }
    }

    return (
        <Modal backdrop={"static"} className="themeModalBig" show={show} onHide={() => dispatch(setInsertNewPrimerPosListData({show: false, shippingDate: new Date(), savedVouchers: [], voucherInput: ""}))}>
            <Modal.Header closeButton>
                <Modal.Title>Δημιουργία Λίστας Αποστολής ACS</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <span style={{fontSize: "13px"}} className={"text-muted"}><i>
                        Κάτι θα μπει εδω...
                    </i></span>
                    <hr />
                    <Row>
                        <Col md={2}>
                            <DateBox
                                label={"Ημερομηνία Αποστολής"}
                                name="shippingDate"
                                required={true}
                                disabled={vouchersLoader}
                                minDate={moment().toDate()}
                                selected={(moment(shippingDate).isValid() && !isEmpty(shippingDate)) ? moment(shippingDate).toDate() : new Date()}
                                onChange={(e) => {
                                    dispatch(setInsertNewPrimerPosListData({...insertListData, shippingDate: e ? moment(e).toDate() : ""}));
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <Button
                                style={{padding:'12px'}}
                                className={"mt-4"}
                                disabled={vouchersLoader}
                                variant={"primary"}
                                onClick={() => loadVouchers()}>
                                {"Φόρτωση Λίστας Αποστολής "}
                                {vouchersLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                            </Button>
                        </Col>
                        {savedVouchers?.length > 0 && (
                            <React.Fragment>
                                <Col md={5}>
                                    <Input
                                        label={"Έλεγχος ACS Voucher"}
                                        id={"check-voucher-input"}
                                        name={"newSerial"}
                                        charLimit={50}
                                        placeholder={"Εισάγετε ή Σκανάρετε ACS Voucher για Έλεγχο"}
                                        type={"text"}
                                        required={true}
                                        value={voucherInput}
                                        onKeyDown={(e) => {
                                            if(e.key === "Enter") {
                                                checkVoucher();
                                            }
                                        }}
                                        onChange={(e) => {
                                            dispatch(setInsertNewPrimerPosListData({...insertListData, voucherInput: e.target.value}));
                                        }}
                                    />
                                </Col>
                                <Col md={1} className={"mr-5"}>
                                    <Button
                                        size={"lg"}
                                        className={"mt-4"}
                                        style={{padding: "0.8rem 2rem"}}
                                        disabled={isEmpty(voucherInput)}
                                        variant="primary"
                                        onClick={() => checkVoucher()}>
                                        Έλεγχος
                                    </Button>
                                </Col>
                            </React.Fragment>
                        )}
                    </Row>
                {showNotFoundMessage && (
                  <React.Fragment>
                      <hr />
                      <span style={{fontSize: "15px", color: "red", fontWeight: "bold", textAlign: "center"}}>
                    ΠΡΟΣΟΧΗ! Τα παρακάτω voucher δεν βρέθηκαν στην λίστα Αποστολής της ACS με την συγκεκριμένη ημερομηνία. Παρακαλώ μεταβείτε στις σελίδες των αντίστοιχων σελίδων των συσκευών, ακυρώστε τα Voucher και εκδώστε νέα και ύστερα προσπαθήστε να εκδώσετε νέα λίστα Αποστολής.
                    ΠΡΟΣΟΧΗ! ΜΗΝ ΞΕΧΑΣΕΤΕ να αλλάξετε και τα αντίστοιχα αυτοκόλλητα των Voucher στα πακέτα.
                    </span>
                  </React.Fragment>
                )}
                <div style={{maxHeight: isMobileScreen ? "60vh" : "70vh", overflowY: 'auto', overflowX: isMobileScreen? 'auto' : 'hidden'}}>
                    <Row style={{overflowX: "auto"}}>
                        <Col md={12}>
                            <table className={"simpleClassicTable clientMovementsReportTable mt-2"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                                <colgroup>
                                    <col span={1} style={{width: "2%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "2%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "6%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th style={{border: "1px solid gray"}}>A/A</th>
                                    <th style={{border: "1px solid gray"}}>Κωδικός Voucher</th>
                                    <th style={{border: "1px solid gray"}}>Πελάτης</th>
                                    <th style={{border: "1px solid gray"}}>Τόπος Παράδοσης</th>
                                    <th style={{border: "1px solid gray"}}>Πλήθος Συσκευών</th>
                                    <th style={{border: "1px solid gray"}}>Συσκευές</th>
                                    <th style={{border: "1px solid gray"}}>Ενέργειες</th>
                                </tr>
                                </thead>
                                <tbody>
                                {savedVouchers?.map((row, idx) => {
                                    if(showUnchecked && row?.checked) return (<React.Fragment></React.Fragment>);
                                    return (
                                    <tr key={`insertPosTable-${idx}`} style={{height: "45px", backgroundColor: row?.notFound ? "#ffcfcf" : row?.checked ? "#b1fcb1" : row["serials"]?.length > 1 ? "#fff5bd" : "white"}}>
                                        <td style={{border: "1px solid gray"}}>
                                            {row?.checked ? <FaCheck size={15} color={"green"} /> : ""}
                                            {row?.notFound ? <MdCancel size={15} color={"red"} /> : ""}
                                            {" "}
                                            {idx + 1}</td>
                                        <td style={{border: "1px solid gray"}}>
                                            {row["acsVoucher"]}
                                            {!isEmpty(row?.acsMultipartVouchers) && row?.acsMultipartVouchers?.length > 0 && (
                                                <span>{` (Συνοδευτικά: ${row.acsMultipartVouchers.join(", ")})`}</span>
                                            )}
                                        </td>
                                        <td style={{border: "1px solid gray"}}>{row["client"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["address"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["quantity"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["serials"].join(', ')}</td>
                                        <td style={{border: "1px solid gray", padding: "5px"}}>
                                            <Button style={{padding: "5px"}} variant="primary" onClick={() => {
                                                dispatch(setPrimerPosRequestData({...requestData, acsVoucher: row.acsVoucher, remote: true}));
                                                dispatch(openPrimerPOSReport(TABS_DATA));
                                            }}>
                                                Εμφάνιση Συσκευών
                                            </Button>
                                        </td>
                                    </tr>
                                )})}
                                {savedVouchers?.length === 0 && (
                                    <tr style={{height: "45px"}}>
                                        <td colSpan={7}>Δεν βρέθηκαν Vouchers για την συγκεκριμένη ημερομηνία αποστολής.</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer className="w-100 d-flex justify-content-between align-items-start flex-wrap gap-3">
                <div style={{ flex: "0.1 auto"}}>
                    {savedVouchers?.length > 0 && (
                        <React.Fragment>
                            <div style={{fontSize: "13px"}} className="d-flex justify-content-between align-items-center mb-2">
                            <strong>Σύνοψη Voucher προς Αποστολή:</strong>
                                <Space direction="horizontal">
                                    <span>Εμφάνιση μη ελεγμένων</span>
                                    <Switch className={"mt-1"} style={{backgroundColor: showUnchecked ? "#76AEB7" : ""}} value={showUnchecked} onChange={() => setShowUnchecked(!showUnchecked)} />
                                </Space>
                            </div>
                            <div className="progress-wrapper position-relative" style={{ flexGrow: 1}}>
                                <ProgressBar
                                    now={Math.round((savedVouchers.filter((el) => el?.checked).length / savedVouchers.length) * 100)}
                                    animated
                                    striped
                                    style={{ height: '30px' }}
                                    className={"custom-progress-pending"}
                                />
                                <div className="centered-label">
                                    <span>{savedVouchers.filter((el) => el?.checked).length} / {savedVouchers.length} Vouchers ελέγχθηκαν</span>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="align-self-end">
                    <Button disabled={listLoader || savedVouchers.length === 0 || savedVouchers.some((el) => !el?.checked)} variant="primary" onClick={() => createAcsList()}>
                        Δημιουργία Λίστας Αποστολής{" "}
                        {listLoader && (
                            <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                        )}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default InsertPosListModal;